import { ELanguages } from '@common/enums';
import type { Uuid } from '@common/types';
import type {
    UnsavedLibraryBlockEntity,
    LibraryBlockEntityType,
} from '@web/store/library-blocks/library-blocks.models';

import { inject, Injectable } from '@angular/core';
import { LibraryBlockCategory, TempStatus } from '@web/store/library-blocks/library-blocks.models';
import { TranslationLoaderService } from '@common/services/translation-loader.service';
import { CookieService } from 'ngx-cookie-service';

type CreateLibraryBlockPayload = {
    templateId?: string | number;
    blockId: Uuid;
    lang: ELanguages;
    userId?: number | null;
};
@Injectable({
    providedIn: 'root',
})
export class LibraryBlocksService {
    cookieService: CookieService = inject(CookieService);

    public createDefaultBlockEntity({
        templateId,
        blockId,
        lang,
        userId,
    }: CreateLibraryBlockPayload): UnsavedLibraryBlockEntity {
        const defaultBlock = {
            categoryIds: !userId ? [LibraryBlockCategory.header] : [LibraryBlockCategory.saved],
            name: '',
            blockId,
            tempStatus: TempStatus.new,
            thumbnail: '',
            lang,
            userId,
        } as UnsavedLibraryBlockEntity;

        if (templateId) {
            defaultBlock.templateId = templateId;
        }
        return defaultBlock;
    }

    public copyBlockEntity(
        templateId: Uuid | number,
        blockId: UnsavedLibraryBlockEntity['blockId'],
        block: LibraryBlockEntityType
    ): UnsavedLibraryBlockEntity {
        const copiedBlock = {
            ...block,
            blockId,
            templateId,
            tempStatus: TempStatus.new,
        };

        if ('id' in copiedBlock) {
            delete copiedBlock.id;
        }

        if ('content' in copiedBlock) {
            delete copiedBlock.content;
        }

        return copiedBlock;
    }

    /**
     * Returns the language that can be used to retrieve the block library
     *
     * @returns {ELanguages}
     */

    public getLanguage(): ELanguages {
        const cookieLang = TranslationLoaderService.getCurrentLocale(this.cookieService);
        return [ELanguages.UA, ELanguages.RU].includes(cookieLang) ? cookieLang : ELanguages.EN;
    }
}
